import React from "react";
import { Colors } from "../../Constants/colors";

export enum TextBtnType {
  danger = "danger",
  primary = "primary",
}
interface Props {
  onClick: () => unknown;
  type?: TextBtnType;
  title: string;
}
export const TextButton = ({
  onClick,
  type = TextBtnType.primary,
  title,
}: Props) => {
  const buttomColor = () => {
    switch (type) {
      case TextBtnType.primary:
        return Colors.TiffanyBlue;

      case TextBtnType.danger:
        return Colors.Tomato;

      default:
        return Colors.TangerineOrange;
    }
  };

  return (
    <div
      style={{
        color: buttomColor(),
        fontSize: "14px",
        display: "inline-block",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {title}
    </div>
  );
};
